'use strict';

module.exports = hardBreak;
var u = require('unist-builder');
function hardBreak(h, node) {
  return [h(node, 'br'), u('text', '\n')];
}